<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">企业管理</div>
      <div class="t-t2box">
        <div class="t-t2">以战略为导向 不止量身定制 更要辅导落地</div>
      </div>
    </div>

    <!-- 第一部分 -->
    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">企业运营管理中存在的问题</div>
        <br />
        <!-- <div class="t2">助您洞察市场的真实情况</div> -->
      </div>

      <!-- 内容 -->
      <div class="box1"></div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <!-- 第二部分 -->
    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">一站式解决企业经营管理问题</div>
        <div class="t2">量身定制，实现经营目标</div>
      </div>

      <!-- row2内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/products/qiye/tubiao1.png" alt="" />

          <div class="t1">计划预算</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tubiao2.png" alt="" />

          <div class="t1">组织优化</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tubiao3.png" alt="" />

          <div class="t1">业绩激励</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tubiao4.png" alt="" />

          <div class="t1">重点攻关</div>
        </div>
      </div>
      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <!-- 第三部分 -->

    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">运营管理模式的带来的企业价值</div>
        <div class="t2">打造企业管理终极利器</div>
      </div>

      <!-- row2内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu2@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">效益</div>
              <div class="line"></div>
              <div class="t2">营收目标实现，成本费用 受控，利润有保障</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu3@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">管理</div>
              <div class="line"></div>
              <div class="t2">高效高质量的管理机制形成，重大 项目有突破，日常工作有效率</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu4@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">执行力</div>
              <div class="line"></div>
              <div class="t2">有汇报，有指导，有监督，保障目标 达成和计划执行</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu5@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">士气</div>
              <div class="line"></div>
              <div class="t2">奖优罚劣，主动复制，建立正向积 极文化，提升整体氛围</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConstProduct',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/qiye/banner.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}
//第一部分
.row1 {
  height: 740px;

  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    // border: 1px solid;
    width: 1103px;
    height: 260px;
    margin: 100px auto 150px auto;
    box-sizing: border-box;
    background-image: url(@/image/products/qiye/tu11.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .zixun {
    letter-spacing: 1px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 0px auto;
    // letter-spacing: 1px;
  }
}

.row2 {
  height: 750px;
  overflow: hidden;

  background-color: #f7f8fb;
  position: relative;

  .title {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 120px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 110px auto;
    justify-content: space-around;

    .r2-tiem {
      height: 160px;
      width: 200px;
      position: relative;
      border-radius: 6px;

      img {
        margin-top: 15px;
        margin-left: 20px;
        height: 160px;
        width: 160px;
      }
      .t1 {
        overflow: hidden;
        width: 200px;
        font-size: 21px;
        margin: 20px auto 0 auto;
        text-align: center;
      }
      .t2 {
        margin: 5px auto 0 auto;
        font-size: 21px;
        text-align: center;
      }
    }
  }

  .zixun {
    // position: absolute;
    letter-spacing: 1px;
    bottom: 100px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #4581fb;
    color: #4581fb;
    border-radius: 4px;
    margin: 260px auto;
    letter-spacing: 1px;
  }
}

.row3 {
  height: 750px;
  overflow: hidden;

  background-color: #ffffff;
  position: relative;

  .title {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 120px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 110px auto;
    justify-content: space-around;

    .r2-tiem {
      height: 363px;
      width: 285px;
      position: relative;

      border-radius: 6px;
      padding: 0;

      img {
        position: absolute;
        top: -14px;
        left: -14px;
        width: 110%;
        height: 110%;
      }

      .yy {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        background-color: rgba($color: #000000, $alpha: 0.2);
        .tbox {
          position: absolute;
          bottom: 0;
          color: #fff;
          overflow: hidden;
        }

        .t1 {
          font-size: 28px;
          height: 28px;
          width: 100%;
          text-align: center;
          margin-bottom: 20px;
          letter-spacing: 1px;
        }
        .line {
          height: 3px;
          width: 32px;
          background-color: #ffffff;
          margin: 0px auto 18px auto;
        }
        .t2 {
          width: 74%;
          font-size: 14px;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 35px;
          font-weight: 300;
        }
      }
    }
  }
}
</style>
